import { makeReducer } from '../core/make-reducer';
import { makeActionCreators } from '../core/make-action-creators';
import * as API from '../core/api';
import User from './class';
import Goal from '../goals/class';
import Project from '../projects/class';

export const actions = {
  REQUEST: 'Dora/user/REQUEST',
  RECEIVE: 'Dora/user/SUCCESS',
  FAIL: 'Dora/user/FAIL',
  ADD_GOAL: 'Dora/user/ADD_GOAL',
  UPDATE_GOAL: 'Dora/user/UPDATE_GOAL',
  DELETE_GOAL: 'Dora/user/DELETE_GOAL',
  UPDATE_PROJECTS: 'Dora/user/UPDATE_PROJECTS',
};

export default makeReducer({
  actions,
  handlers: {
    [actions.ADD_GOAL]: (state, action) => ({
      ...state,
      data: {
        ...state.data,
        goals: [...state.data.goals, new Goal(action.goal)],
      },
    }),
    [actions.UPDATE_GOAL]: (state, action) => ({
      ...state,
      data: {
        ...state.data,
        goals: state.data.goals.map((g) => {
          if (g._id === action.goal._id) {
            return new Goal(action.goal);
          }

          return g;
        }),
      },
    }),
    [actions.DELETE_GOAL]: (state, action) => ({
      ...state,
      data: {
        ...state.data,
        goals: state.data.goals.filter((g) => g._id !== action.goal._id),
      },
    }),
    [actions.UPDATE_PROJECTS]: (state, action) => ({
      ...state,
      data: {
        ...state.data,
        projects: action.projects.map((p) => ({
          ...p,
          project: new Project(p.project),
        })),
      },
    }),
  },
});

const actionCreators = makeActionCreators({
  reducerName: 'user',
  actions,
  requestDataCall: (store, params) =>
    API.get('users/me', params).then((res) => new User(res)),
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;
export const addGoal = (goal) => ({ type: actions.ADD_GOAL, goal });
export const updateGoal = (goal) => ({ type: actions.UPDATE_GOAL, goal });
export const deleteGoal = (goal) => ({ type: actions.DELETE_GOAL, goal });
export const updateProjects = (projects) => ({
  type: actions.UPDATE_PROJECTS,
  projects,
});



// WEBPACK FOOTER //
// ./src/user/duck.js